const orderItems = ({ tabIndex: li, pos: lp }, { tabIndex: ri, pos: rp }) => {
    // if same tab index, compare position in DOM
    if (li === ri) {
        return lp - rp;
    }

    // if both have nonzero tab indexes, compare them
    if (li && ri) {
        return li - ri;
    }

    // otherwise, nonzero index comes first
    return li ? -1 : 1;
};

// (jQuery, DOMElement)
const findNextTabStop = (scope, start) => {
    const tabbables = scope
        .find(":tabbable")
        .toArray()
        .map((element, pos) => ({
            element,
            pos,
            tabIndex: element.tabIndex || Number.POSITIVE_INFINITY,
        }))
        .sort(orderItems)
        .map(({ element }) => element);

    const idx = tabbables.indexOf(start);

    // current item is the last item
    if (idx === tabbables.length - 1) {
        // return null if it is the only item
        if (tabbables.length === 1) {
            return null;
        }

        // loop around to front
        return tabbables[0];
    }

    // item not found
    if (idx < 0) {
        return null;
    }

    // next item
    return tabbables[idx + 1];
};

export default findNextTabStop;